import $ from 'jquery'
import _ from 'lodash'
import { document } from 'ssr-window'
import Vue from 'vue'
import KUuid from '../../core/utils/KUuid'
import KIcon from '../icon'
import { isVNode, KNextZIndex } from '../../core/utils'

const contentPropValidate = function (value) {
  return typeof value === 'string' || typeof value === 'number' || isVNode(value)
}

const Toast = Vue.extend({
  props: {
    id: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'light',
    },
    message: {
      validator(value) {
        return contentPropValidate(value)
      },
      default: '',
    },
    template: {
      // 自定义模板
      validator(value) {
        return contentPropValidate(value)
      },
      default: '',
    },
    html: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: '',
    },
    duration: {
      // 自动关闭时间，值为 0 时，toast 不会消失
      type: Number,
      default: 3000, // million seconds
    },
    container: {
      type: String,
      default: 'body',
    },
    toastClass: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      cssNamespace: 'km-toast',
    }
  },
  computed: {
    css() {
      const toast = {
        [`${this.cssNamespace}`]: true,
        [`${this.cssNamespace}--${this.type}`]: this.type,
      }
      if (this.template) {
        toast['is-customize'] = true
        if (this.toastClass) {
          toast[this.toastClass] = true
        }
      }
      return toast
    },
  },
  created() {
    this.startTimer()
  },
  methods: {
    clearTimer() {
      clearTimeout(this.timer)
      this.timer = null
    },
    startTimer() {
      this.clearTimer()
      if (+this.duration === 0) {
        return
      }
      this.timer = setTimeout(() => {
        this.destroy()
      }, this.duration)
    },
    destroy() {
      this.clearTimer()
      this.$emit('destroy', this.id)
    },
  },
  render() {
    const iconProps = {
      attrs: {
        circle: true,
        icon: this.icon,
      },
    }

    if (this.template) {
      return (
        <div
          class={this.css}
        >
          {this.template}
        </div>
      )
    }

    return (
      <div
        class={this.css}
      >
        <div class={this.cssNamespace + '__content'}>
          <KIcon
            v-show={this.icon}
            class={this.cssNamespace + '__icon'} {...iconProps} />
          <div
            v-show={this.message}
            class={this.cssNamespace + '__message'}
          >
            {this.html ? <span domPropsInnerHTML={this.message} /> : this.message}
          </div>
        </div>
      </div>
    )
  },
})

const ToastManager = Vue.extend({
  components: {},
  data() {
    return {
      queue: [],
      queueSize: 1,
      container: 'body',
      positionStyle: {},
    }
  },
  computed: {
    wrapperCss() {
      return 'km-toast__wrapper'
    },
    innerCss() {
      return 'km-toast__inner'
    },
  },
  mounted() {
  },
  methods: {
    getPositionStyle() {
      if (this.container === 'body') {
        return {
          top: '50%',
          left: '50%',
        }
      } else {
        const scrollTop = $(document).scrollTop()
        const $container = $(this.container).eq(0) || $('body')
        const containerHeight = $container.outerHeight()
        const containerWidth = $container.outerWidth()
        const containerTop = $container.offset().top - scrollTop
        const containerLeft = $container.offset().left
        const top = parseInt(containerTop + containerHeight * 0.5)
        const left = parseInt(containerLeft + containerWidth * 0.5)
        return {
          top: top + 'px',
          left: left + 'px',
        }
      }
    },
    removeAll() {
      setTimeout(() => {
        this.queue.shift()
        if (this.queue.length) {
          this.removeAll()
        }
      }, 100)
    },
    removeToast(id) {
      const index = _.findIndex(this.queue, ['id', id])
      if (index > -1) {
        this.queue.splice(index, 1)
      }
    },
    addToast(options) {
      if (typeof options === 'string' || isVNode(options)) {
        options = {
          message: options,
        }
      }

      this.container = options.container || 'body'
      this.positionStyle = this.getPositionStyle()

      if (this.queue.length >= this.queueSize) {
        this.queue.shift()
      }

      const id = KUuid()

      this.queue.push(
        _.assign(options, {
          id,
        }),
      )
      this.$el.style.zIndex = KNextZIndex()

      return id
    },
  },
  render() {
    return (
      <div
        class={this.wrapperCss}
        style={this.positionStyle}
      >
        {_.map(this.queue, (toast) => {
          const props = {
            props: toast,
          }
          return <Toast
            onDestroy={this.removeToast}
            key={toast.id} {...props} />
        })}
      </div>
    )
  },
})

let toastManager

export default {
  name: 'KToast',
  toast(options) {
    if (options.action && options.action === 'clear') {
      toastManager && toastManager.removeAll()
      return
    }

    if (toastManager === undefined) {
      /* eslint-disable-next-line */
      toastManager = new ToastManager({
        el: document.createElement('div'),
      })
      $('body').append(toastManager.$el)
    }

    return toastManager.addToast(options)
  },
}
